//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MembershipCreditCardDisplayItem } from './MembershipCreditCardDisplayItem';
import { MembershipPaymentProcessor, MembershipSubscriptionStatus } from './Enums';

export class MembershipSubscriptionDisplayItem extends ItemBase {
    CreditCard: MembershipCreditCardDisplayItem | null = null;
    CreditCardExpiryNoticeHasBeenSent: boolean = false;
    MembershipPlanID: string | null = null;
    NextBillingDate: string | null = null;
    PaymentFailedNoticeHasBeenSent: boolean = false;
    PaymentProcessor: MembershipPaymentProcessor = MembershipPaymentProcessor.None;
    PaymentProcessorCustomerIDHash: string | null = null;
    Status: MembershipSubscriptionStatus = MembershipSubscriptionStatus.Active;
    TrialStartDateUTC: string = "1970-01-01T00:00:00";
    TrialEndDateUTC: string = "1970-01-01T00:00:00";
    UnsubscribedDateUTC: string | null = null;

    constructor(initializer?: Partial<MembershipSubscriptionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MembershipSubscriptionDisplayItem";
}
